import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 还款记录
   * 目前仅用于宜享花APP
   */
  {
    path: '/record/repay',
    meta: {
      title: '还款记录',
      background: '#F2F5FF',
      customNavBar: true,
    },
    component: () => import('@/views/record/repay/index.vue'),
  },
  /**
   * 借款记录
   */
  {
    path: '/record/loan',
    meta: {
      title: '借款记录',
      customNavBar: true,
    },
    component: () => import('@/views/record/loan/index.vue'),
  },
  /**
   * 借款记录-合同查询
   */
  {
    path: '/record/loan/:applyId/contract',
    meta: {
      title: '合同信息',
      customNavBar: true,
    },
    component: () => import('@/views/record/loan/contract.vue'),
  },
] as RouteConfig[];
